/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { use } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "../../core/redux/store";
import { setSlide, setTab } from "../../core/redux/action";
import { dispatch } from "d3";
import { IoIosArrowForward, IoIosArrowBack, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const Sidebar = () => {
  const translation = useSelector((state) => state.root.translation);
  const sidebarData = useMemo(() => SidebarData(translation), [translation]);
  // const SidebarData = useSelector((state) => state.sidebar_data);
  // console.log(sidebarData, "sidebar");
  const navigate = useNavigate();
  const [slide, setSlide] = useState(true);
  const dispatch = useDispatch();
  const Location = useLocation();
  const subMenu = useSelector((state) => state.root.subMenu);
  const [dropDown, setDropDown] = useState({});
  //
  const safeJsonParse = (item, defaultValue) => {
    try {
      return JSON.parse(item) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  };
  const permissions = safeJsonParse(localStorage.getItem("permissions"), null); //useSelector(state => state.root.permissions) || [];
  const roleTitle = localStorage.getItem("roleTitle");

  const roleTitleAdmin = localStorage.getItem("roleTitleAdmin"); //useSelector(state => state.root.roleTitleAdmin) || [];
  // Check if user has permission to view a specific module
  const hasPermission = (permissionKey) => {
    return (
      roleTitle === roleTitleAdmin ||
      (Array.isArray(permissions) &&
        permissions.some(
          (p) =>
            p.Module &&
            p.Permission &&
            p.Module.toLowerCase() === permissionKey &&
            p.Permission.toLowerCase() === "view"
        ))
    );
  };
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const filteredSidebarData = sidebarData.reduce((acc, mainLabel) => {
    const filteredSubmenuItemsByPermission = mainLabel?.submenuItems
      ?.map((submenuItem) => {
        const filteredSubData =
          submenuItem?.subData?.filter((subItem) =>
            hasPermission(subItem.key)
          ) || [];
        if (filteredSubData.length > 0 || !submenuItem.subData) {
          return {
            ...submenuItem,
            subData: filteredSubData,
          };
        }
        return null;
      })
      .filter(Boolean);
    if (filteredSubmenuItemsByPermission.length > 0) {
      acc.push({
        ...mainLabel,
        submenuItems: filteredSubmenuItemsByPermission,
      });
    }

    return acc;
  }, []);
  useEffect(() => {
    const subMenu = filteredSidebarData?.find((sub) =>
      sub.submenuItems.some((item) =>
        item.subData.some((subItem) => subItem.link === location.pathname)
      )
    );
    //
    if (subMenu?.submenuItems?.[0]?.subData?.[0]?.link) {
      dispatch(setTab(subMenu));
      setSlide(true);
    } else {
      dispatch(setTab(null));
      setSlide(false);
    }
  }, [sidebarData]);

  const subHandler = (menu) => {
    const check = menu.submenuItems.length > 0;
    const dom = document?.body?.style;
    dom.pointerEvents = "none";
    setTimeout(() => {
      dom.pointerEvents = "auto";
    }, 800);
    if (check && menu.submenuItems[0]?.subData[0]?.link) {
      dispatch(setTab(menu));
      navigate(menu.submenuItems[0]?.subData[0]?.link);
      setSlide(true);
    } else if (!menu.submenuItems[0]?.subData[0]?.link) {
      dispatch(setTab(null));
      navigate(menu.link);
      setSlide(false);
    }
  };
  const handleArrowDir = (v) => {
    setSlide(v);
  };
  const dropDownHandle = (index) => {
    let pay = {}
    if(dropDown[index]){
      pay = {...dropDown, [index]:false}
    }else{
      pay = {...dropDown, [index]:true}
    }
    setDropDown(pay);
  }
  return (
    <div id="toggle_btn" className="sidebar-main-contain">
      {/* {slide && subMenu?.submenuItems?.length > 0 && ( */}
      <div
        className={`submenuWrapper ${slide && subMenu ? "activeslide" : ""} ${
          slide && subMenu && subMenu?.submenuItems?.length > 0
            ? "slideShow"
            : ""
        }`}
      >
        <div className="submenu-block">
          <ul>
            {subMenu?.submenuItems?.map((item, key) => {
              
              return <>
                <h6 className="sub-header-title" onClick={() => dropDownHandle(key)}>{item?.title} {item.subData.length >0 ? !dropDown[key] ?<IoIosArrowUp/>:<IoIosArrowDown/>:""}</h6>
                <div className={`sub-menu-hide-content ${!dropDown[key] ? 'active-drops':''}`}>
                {
                  item.subData.map((item1, i) => (
                    <li
                      key={i}
                      className={`nav-list ${
                        (location.pathname === item1?.link && "active-submenu") ||
                        ""
                      }`}
                    >
                      <Link to={item1?.link} className={`submenu-icons`}>
                        {item1?.icon} {item1.label}
                      </Link>
                    </li>
                  ))
                }
                </div>
              </>
            })}
          </ul>
          <div className="bottom-arrows">
            {/* <div className="arrow-forward">
                <IoIosArrowForward />
              </div> */}
            {slide && (
              <div className="arrow-back" onClick={() => handleArrowDir(false)}>
                <IoIosArrowBack />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* )} */}
      {!slide && subMenu?.submenuItems && (
        <div className="bottom-arrows-forward">
          <div className="arrow-forward" onClick={() => handleArrowDir(true)}>
            <IoIosArrowForward />
          </div>
        </div>
      )}
      <div className="sidebar mini-bar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredSidebarData?.map((mainLabel, index) => (
                  <li
                    className={`submenu-open ${
                      (subMenu &&
                        mainLabel.key === subMenu.key &&
                        "active-menu") ||
                      (mainLabel.key === "home" &&
                        Location.pathname == "/" &&
                        "active-menu")
                    }`}
                    key={index}
                    onClick={() => subHandler(mainLabel)}
                  >
                    <h6 className="main-label">
                      <span className="main-icon">{mainLabel?.icon}</span>
                      <span className="submenu-hdr">{mainLabel?.label}</span>
                    </h6>
                    {/* <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array?.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array?.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <>
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen == title?.label ? "subdrop" : ""
                                } ${
                                  title?.link?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }
                            `}
                              >
                                {title?.icon}
                                <span>{title?.label}</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen == title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                     
                                      <Link
                                        to={item?.link}
                                        className={
                                          item?.submenuItems
                                            ?.map((link) => link?.link)
                                            .includes(Location.pathname) ||
                                          item?.link == Location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar == item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, titleIndex) => (
                                            <li key={titleIndex}>
                                              
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar == items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ==
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </>
                        );
                      })}
                    </ul> */}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
